export class PurchaseOrderRequest {
  constructor(groups) {
    this.purchaseOrder = groups;
  }
}
